import { Component, HostListener, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { MyTranslationService } from '../../../shared/service/myTranslation.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SettingsModel } from '../../../shared/Model/setting.model';
import { SettingService } from '../Services/header.service';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared/Module/shared.module';
import { Subscription } from 'rxjs';
import { ToasterComponent } from "../../../shared/Componet/toaster/toaster.component";
import { AuthService } from '../../../shared/service/auth.service';
import { profileService } from '../../../pages/profile/Services/profile.service';
import { imageService } from '../../../shared/service/image.service';
import { PlaylistsModel } from '../../../pages/ConfernceAndSchool/school/Model/school.model';
import { SchoolService } from '../../../pages/ConfernceAndSchool/school/Services/school.service';

@Component({
  selector: 'app-header',
  imports: [RouterLink, TranslateModule, CommonModule, SharedModule, ToasterComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent {
  settings: SettingsModel[] = []
  isSubmenuOpen: { [key: string]: boolean } = {};
  private subs = new Subscription();   // container for all subscriptions
  showToast = false;
  toastMessage = '';
  toastType: 'success' | 'error' = 'success';
  isLoggedIn = false;
  previewUrl: string | ArrayBuffer | null = null;
  Playlists: PlaylistsModel[] = [];
  selectedPlaylist!: number;


  private authService = inject(AuthService);

  private imageService = inject(imageService)

  private settingService = inject(SettingService)
  private router = inject(Router);
  private schoolService = inject(SchoolService);


  ngOnInit(): void {

    const userName = localStorage.getItem("userName");
    if (userName) {
      this.imageService.loadUserImage(userName);
    }

    this.loadData();

    this.authService.loginState$.subscribe((state) => {
      this.isLoggedIn = state;

      if (!state) {
        this.imageService.clear();
      }

      this.loadLookups();
    });

    this.subs.add(
      this.imageService.userImage$.subscribe(img => {
        this.previewUrl = img;
      })
    );
  }

  loadData() {
    const sub = this.settingService.getAllSettings().subscribe({
      next: (data) => {
        this.settings = data.value
      },
      error: (err) => {
        console.error('Error loading About us:', err);
      }
    })
    this.subs.add(sub);
  }

  // menu
  isSidebarOpen = false;

  openSidebar() {
    this.isSidebarOpen = true;
  }
  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  closeSidebar() {
    this.isSidebarOpen = false;
  }

  toggleSubmenu(name: string) {
    // اقفلي كل الـ submenu التانية
    Object.keys(this.isSubmenuOpen).forEach(key => {
      if (key !== name) {
        this.isSubmenuOpen[key] = false;
      }
    });

    // افتحي / اقفلي submenu المطلوبة
    this.isSubmenuOpen[name] = !this.isSubmenuOpen[name];
  }

  readonly _TranslateService = inject(MyTranslationService);
  private translate = inject(TranslateService)

  // بدل المتغير — اعمل Getter
  get currentLang(): string {
    return localStorage.getItem('lang') || 'ar';
  }

  get nextLang(): string {
    return this.currentLang === 'ar' ? 'en' : 'ar';
  }

  toggleLang(): void {
    this._TranslateService.changeLang(this.nextLang);
    const userName = localStorage.getItem('userName');
    if (userName) {
      this.imageService.loadUserImage(userName);
    }
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();   // unsubscribe from all
  }

  logout() {
    let userId: any
    userId = localStorage.getItem('userId');
    const params = {
      "userID": userId
    };
    this.settingService.logout(params).subscribe({
      next: (res) => {
        this.toastType = 'success';
        this.toastMessage = this.translate.instant('LOGOUT.SUCCESS');
        this.showToast = true;
        localStorage.removeItem("token");
        localStorage.removeItem("userData");
        localStorage.removeItem("userId");
        localStorage.removeItem("isMember");
        localStorage.removeItem("userName");
        localStorage.removeItem("isAdmin");

        this.imageService.setUserImage(null);


        setTimeout(() => this.showToast = false, 3000);
        setTimeout(() =>
          this.router.navigate(['/home'])
          , 2000);
        this.authService.setLoggedOut();
      },
      error: (err) => {
        this.toastMessage = this.translate.instant('LOGOUT.ERROR');
      }
    });
  }

  handleLogout() {
    this.closeSidebar();
    this.logout();
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const sidebar = document.getElementById('side-bar');
    const menuBtn = document.getElementById('menu-btn');

    if (
      this.isSidebarOpen &&
      sidebar &&
      !sidebar.contains(event.target as Node) &&
      menuBtn &&
      !menuBtn.contains(event.target as Node)
    ) {
      this.closeSidebar();
    }
  }


  loadLookups() {
    this.schoolService.getPlaylists().subscribe(res => {
      if (res.succeeded) {
        this.Playlists = res.value;
        this.selectedPlaylist = this.Playlists[0]?.id;
      }
    });


  }

}
